const BASE_URL = `${process.env.REACT_APP_BASE_URL}`;

interface IImageUrl {
  src: string;
  width: number;
  height: number;
  objectFit?: 'cover' | 'contain';
  isImageServer?: boolean;
}

export const imageUrl = ({ src, height, width, objectFit = 'cover', isImageServer }: IImageUrl) => {
  if (!src) return '';
  return BASE_URL.includes('backoffice') && isImageServer
    ? `${BASE_URL.replace('backoffice', 'media')}${src}/${width}/${height}/${objectFit}/`
    : `${BASE_URL}${src}`;
};

export const videoUrl = (src: string) => {
  return `${BASE_URL}${src}`;
};

export const fileUrl = (src?: string) => {
  if (!src) return '';
  return `${BASE_URL}${src}`;
};
